import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getServiceDetails = createAsyncThunk(
    'serviceDetails/getServiceDetails',
    async ({ serviceId, token }, { rejectWithValue }) => {
    try {
        console.log('getServiceDetails - serviceId:', serviceId);
        console.log('getServiceDetails - token:', token ? 'presente' : 'non presente');
        
        const url = `${import.meta.env.VITE_API_BASE_URL}/services?serviceId=${serviceId}`;
        const headers = { 'Content-Type': 'application/json', 'auth-token': token };
        const options = { method: 'GET', headers };
        
        console.log('getServiceDetails - URL:', url);
        console.log('getServiceDetails - headers:', JSON.stringify(headers));
        
        const response = await fetch(url, options);
        console.log('getServiceDetails - response status:', response.status);
        
        if (!response.ok) {
            const error = await response.json();
            console.error('getServiceDetails - error:', error);
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        } else {
            const result = await response.json();
            console.log('getServiceDetails - result:', result);
            return result
        }
    } catch (error) {
        console.error('getServiceDetails - catch error:', error);
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const serviceDetailsSlice = createSlice({
    name: "serviceDetails",
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getServiceDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getServiceDetails.rejected, (state, action) => {
                state.data = null;
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento dei dettagli servizio.";
                state.isLoading = false;
            })
            .addCase(getServiceDetails.fulfilled, (state, action) => {
                state.error = null;
                state.data = action.payload;
                state.isLoading = false;
            })
    }
})

// Selectors
export const selectServiceDetailsData = (state) => state.serviceDetails.data;
export const selectServiceDetailsIsLoading = (state) => state.serviceDetails.isLoading;
export const selectServiceDetailsError = (state) => state.serviceDetails.error;

export default serviceDetailsSlice.reducer;
